import * as React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

import type { ForwardRefComponent } from '@/components/Polymorphic/Polymorphic';

type InputAdornmentType = {
  /**
   * internal prop, to know where to place the andornment
   */
  position?: 'end' | 'start';
};

const StyledContainer = styled.div<Pick<InputAdornmentType, 'position'>>`
  ${tw`px-3 absolute inset-y-0 flex items-center space-x-2 pointer-events-none`}
  ${({ position }) => position === 'start' && tw`left-0`}
  ${({ position }) => position === 'end' && tw`right-0`}

  button {
    ${tw`pointer-events-auto`}
  }
`;

export const InputAdornment = React.forwardRef(
  (
    { as: Comp = StyledContainer, position = 'end', css, ...rest },
    forwardRef
  ) => {
    return <Comp ref={forwardRef} position={position} {...rest} />;
  }
) as ForwardRefComponent<'div', InputAdornmentType>;
